<template>
<div>
	<Loader :show="loading"></Loader>

	<div class="fullscreen" >
		<div class="head head-with-brand big">
			<div class="container">
				<div class="btn icon icon-close invert" @click="cancelControl"></div>
				<small>CHASSIS</small>
				<h1>{{control.car.chassis_number}}</h1>
				<h2>{{control.car.brand.title}} {{control.car.model}}</h2>
				<div class="brand" v-if="control.car.brand.logo" :style="{backgroundImage:`url(${API_URL+control.car.brand.logo.urlThumb})`}"></div>
			</div>
		</div>

		<div class="content">
			<div class="container">

				<div class="text-center">
					<h1 class="mt-1 mb-1" v-if="action=='out'">Inicio de traslado</h1>
					<h1 class="mt-1 mb-1" v-if="action=='in'">Fin de traslado</h1>
					
				</div>
				
				<div v-if="action=='out'">
					<b-form-group label="Destino del vehículo" class="mt-4">
						<b-form-input
							v-model="form.transfer_to"
							placeholder="Ingrese a donde se trasladará el vehículo"
							:state="!validation.hasError('form.transfer_to')" 
						></b-form-input>
						<b-form-invalid-feedback>Ingrese a donde se trasladará el vehículo</b-form-invalid-feedback>
					</b-form-group>	
				</div>
				
				<div v-if="action=='in'">

					<b-form-group label="Nombre de quien recibe" class="mt-4">
						<b-form-input
							v-model="form.transfer_received_by"
							placeholder="Ingrese el nombre de quien recibe"
							:state="!validation.hasError('form.transfer_received_by')" 
						></b-form-input>
						<b-form-invalid-feedback>Ingrese el nombre de quien recibe el vehículo</b-form-invalid-feedback>
					</b-form-group>

					<b-form-group label="Firma" class="mt-4 mb-4">
						<div class="invalid-feedback d-block" v-if="validation.hasError('form.transfer_received_by_signature')">Ingrese la firma de quien recibe el vehículo</div>					
						<SignatureInput v-model="form.transfer_received_by_signature"></SignatureInput>
					</b-form-group>

				</div>

				<b-form-group label="Comentarios" class="mt-4">
					<textarea-autosize
					placeholder="Comentarios"
					v-model="form.comments"
					:min-height="30"
					:max-height="350"
					class="form-control"
					/>
				</b-form-group>
				
			</div>
		</div>
		<div class="footer">
			<div class="container">
				<div class="btn btn-block btn-primary" @click="nextStep()">
					Continuar
				</div>
			</div>
		</div>
	</div>
	
	<ControlSuccess 
		v-if="control.step=='ControlSuccess'"
		:control="controlCreated"
	></ControlSuccess>

</div>
</template>


<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import { mapState, mapMutations } from 'vuex'
import Loader from '@/components/Loader'
import ControlSuccess from '@/views/controls/ControlSuccess'
import SignatureInput from '@/components/SignatureInput'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'CarToMove',
	mixins:[mixins],
	components: {
		Loader,
		ControlSuccess,
		SignatureInput
	},
	data(){
		return{
			API_URL: process.env.VUE_APP_API_URL,
			loading: false,
			controlCreated: null,
			action: this.$route.params.action,
			form:{
				transfer_to: null,
				transfer_received_by: null,
				transfer_received_by_signature: null,
				comments: null,
			}
		}
	},
	computed: {
		...mapState(['control'])
	},
	validators: {
		'form.transfer_to': function (value) {
			if(this.action=='out'){
				return Validator.value(value).required();
			}
		},
		'form.transfer_received_by': function (value) {
			if(this.action=='in'){
				return Validator.value(value).required();
			}
		},
		'form.transfer_received_by_signature': function (value) {
			if(this.action=='in'){
				return Validator.value(value).required();
			}
		},
	},
	methods:{
		...mapMutations(['saveControl','deleteControl']),
		cancelControl(){
			this.$router.push(`/control/${this.control.car.id}`)
			this.deleteControl()
		},
		nextStep () {
			if( this.control.step == 'main' ) {
				this.finishControl()
				return
			}
		},
		async finishControl(){
			if(!this.loading && await this.checkValidation() ) {
				this.loading = true
				let dataInput = {
					car_id		: this.control.car.id,
					action		: this.action,
					transfer_to : this.form.transfer_to,
					transfer_received_by : this.form.transfer_received_by,
					transfer_received_by_signature	: this.form.transfer_received_by_signature,
					comments	: this.form.comments,
				}
				this.$apollo.mutate({
					mutation: gql`mutation ( $data:ControlTransferInput! ){
						controlTransfer( data: $data) {
							id
							car{
								id
							}
							user{
								name
							}
							type
							typeText
							transfer_to
							comments
							files{
								id
								url
								urlThumb
							}
							created_at
						}
					}`,
					variables: {
						data: dataInput
					}
				})
				.then((data) => {
					this.controlCreated = data.data.controlTransfer
					this.loading = false
					this.control.step = 'ControlSuccess'
				})
				.catch( (error) => {
					this.parseGQLErrors(error)
					this.loading = false
				})
			}
		}
	}
	
}
</script>

<style scoped lang="scss">

</style>
